<template>
  <div class="side-menu" id="sidebar" ref="sideBar">
    <ul class="nav flex-column">
      <div style="width:100%">
        <router-link
          class="item nav-link"
          role="tab"
          v-for="(item, key) in menu"
          :to="{ name: item.to }"
          tag="li"
          active-class="active"
          :key="key"
        >
          <div style="margin:auto auto auto 3rem" @click="hideSidebar">
            <p id="itemName">{{item.name}}</p>
          </div>
        </router-link>
      </div>
    </ul>
  </div>
</template>

<script>
/**
 * @author Fangzhou
 * @description the side bar of dashboard, contain navigation button which can tigger board switch event
 * @module bar
 * @name  SideBar
 */

export default {
  /**
   * @property menu {data} JsonArray which contain the information navigation on sidebar would need
   */
  data() {
    return {
      username: window.localStorage.getItem("username"),
      menu: [
        {
          name: "Info",
          to: "user-info",
          active: true
        },
        {
          name: "Subscription",
          to: "sub-info",
          active: false
        },
        {
          name: "Payment",
          to: "payment-info",
          active: false
        },
        {
          name: "Download History",
          to: "download-info",
          active: false
        },
        {
          name: "API Keys",
          to: "api-keys-info",
          active: false
        }
      ],
      collapse: true
    };
  },
  methods: {
    showLogout() {
      $("#logout").modal("show");
    },
    toHome() {
      this.$router.push({ name: "advertising-page" });
    },
    toggleCollapse() {
      this.collapse = !this.collapse;
    },
    hideSidebar() {
      console.log(this.$refs.sideBar.classList);
      this.$refs.sideBar.classList.remove('active')
    }
  }
};
</script>
<style lang="css" scoped>
.side-menu {
  background-color: white;
  overflow-x: hidden;
  height: 100vh;
  box-shadow: 0 0 11px 0 rgba(198, 192, 192, 0.5);
  transition: 0.5s;
  font-family: Raleway;
  padding-top: 46px;
  margin: 0;
  min-width: 0px;
  width: 0;
  /* transform: translateX(-100%); */
  /* max-width: 225px; */
}

.side-menu.active {
  min-width: 225px;
  margin: 0 15px 0 1px;
  /* transform: translateX(100%); */
}

.nav {
  height: 100%;
  /* justify-content: space-between; */
  align-items: center;
}

.icon:hover {
  cursor: pointer;
}

.nav-link {
}

.nav-link.router-link-exact-active {
  background-color: #d8d8d84d;
}

.nav-link:hover {
  color: white;
  /* opacity: 0.5;
  transition: all 0.5s; */
}

.nav-head {
  background-color: #1b2e38;
  color: white;
  font-size: 20px;
  font-weight: bold;
  word-wrap: break-word;
  padding: 15px;
}

.icon {
  width: 32px;
}

.item-text {
  width: 100%;
  overflow: hidden;
}

.item {
  /* -ms-flex-align: center!important;
  align-items: center!important; */
  height: 92px;
  width: 100%;
  display: flex;
  font-weight: bold;
}

.item:hover {
  cursor: pointer;
  background-color: #d8d8d84d;
  font-weight: bold;
}

.nav-icon {
  margin: auto;
  background-color: #f5a623;
  border-radius: 4px;
  width: 40px;
  height: 40px;
}

#itemName {
  color: #656666;
  font-size: 1rem;
  letter-spacing: 0.47px;
}

#itemName:hover {
  cursor: pointer;
  /* opacity: 0.5; */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.overlay-menu {
  width: 160px !important;
  /* position: fixed;
  z-index: 99; */
}

.nav-link:hover {
  cursor: pointer;
}

@media only screen and (min-width: 992px) {
  .side-menu,
  .side-menu.active {
    min-width: 270px;
    margin: 0 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fixed/account-side-menu.vue